"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("lodash/bind"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ssrWindow = require("ssr-window");

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _NotificationPropTypes = _interopRequireDefault(require("./NotificationPropTypes"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var Notification =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Notification, _Component);

  function Notification(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Notification);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Notification).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onHideClick", function (evt) {
      _this._hide();
    });
    var duration = props.duration,
        autoClose = props.autoClose;

    if (autoClose) {
      _this._hideTimeout = _ssrWindow.window.setTimeout((0, _bind.default)(_this._hide, (0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this))), duration);
    }

    _this._ICONS = {
      info: 'hero-car',
      success: 'check-circle',
      warning: 'exclamation-triangle',
      error: 'exclamation-circle'
    };
    return _this;
  }

  (0, _createClass2.default)(Notification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _ssrWindow.window.setTimeout(function () {
        _dom.default.addClass(_this2._notification, 'Notification-showing');
      }, 100);
    }
  }, {
    key: "_hide",
    value: function _hide() {
      var _this3 = this;

      var _this$props = this.props,
          onHidden = _this$props.onHidden,
          onRemove = _this$props.onRemove;

      if (this._hideTimeout) {
        _ssrWindow.window.clearTimeout(this._hideTimeout);
      }

      _dom.default.removeClass(this._notification, 'Notification-showing');

      _ssrWindow.window.setTimeout(function () {
        _dom.default.removeClass(_this3._notification, 'Notification-showing');

        if (onHidden) {
          onHidden(_this3.props);
        }

        onRemove();
      }, 500);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          type = _this$props2.type,
          message = _this$props2.message,
          showClose = _this$props2.showClose;
      var classes = (0, _classnames.default)('Notification', "Notification-".concat(type), className);
      return _react.default.createElement("div", {
        className: classes,
        ref: function ref(node) {
          _this4._notification = node;
        }
      }, _react.default.createElement("div", {
        className: "Notification-content-container container"
      }, _react.default.createElement(_Icon.default, {
        name: this._ICONS[type]
      }), _react.default.createElement("div", {
        className: "Notification-content"
      }, message), showClose && _react.default.createElement(_Button.default, {
        className: "Notification-hide",
        onClick: this._onHideClick
      }, _react.default.createElement(_Icon.default, {
        name: "times"
      }))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Notification;
}(_react.Component);

exports.default = Notification;
(0, _defineProperty2.default)(Notification, "propTypes", (0, _objectSpread2.default)({}, _NotificationPropTypes.default, {
  // onRemove is added by the NotificationContainer for internal use and should not be documented
  onRemove: _propTypes.default.func.isRequired
}));
(0, _defineProperty2.default)(Notification, "defaultProps", {
  type: 'info',
  duration: 3000,
  showClose: true,
  autoClose: true
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Notification, "Notification", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Notification/Notification.jsx");
  leaveModule(module);
})();

;